import api from '@/core/apiclient'
import { actionTypes } from '@/core/constants'

export default {
	async [actionTypes.PROCESSO.BUSCAR_POR_ID](context, idProcesso) {
		const { data } = await api.processo.buscarProcessoPorId(idProcesso)
		return data
	},

	async [actionTypes.PROCESSO.BUSCAR_PROCESSOS_LISTAGEM]({ state }) {
		const { filtro, paginacao } = state
		const { data } = await api.processo.buscarListagem(filtro, paginacao)
		return data
	},

	async [actionTypes.PROCESSO.BUSCAR_ORGAOS_USUARIO_FILTRO](context, idOrgaoPromotor) {
		const { data } = await api.processo.buscarOrgaosUsuarioFiltro(idOrgaoPromotor)
		return data
	},

	async [actionTypes.PROCESSO.BUSCAR_ORGAOS_QUANTIFICARAM_NO_PROCESSO](context, objt) {
		const { data } = await api.processo.buscarOrgaosQuantificaramNoProcesso(objt)
		return data
	},
}
